import { z } from 'zod';

import { type BaseItem } from '../common.js';

export enum VoicePersonaProvider {
  ElevenLabs = 'ElevenLabs',
  OpenAi = 'OpenAi',
  Cartesia = 'Cartesia',
}

export enum LlmModelCompatibility {
  RealtimeVoiceOnly = 'RealtimeVoiceOnly',
  All = 'All',
  TextBasedOnly = 'TextBasedOnly',
}

export const BaseVoicePersonaSchema = z.object({
  provider: z.nativeEnum(VoicePersonaProvider),
  personaId: z.string(),
  displayName: z.string(),
  llmModelCompatibility: z.nativeEnum(LlmModelCompatibility),
});

type BaseVoicePersona = z.infer<typeof BaseVoicePersonaSchema>;
export type VoicePersona = BaseItem & BaseVoicePersona;

export const FindAllOptionsSchema = z.object({
  provider: z.nativeEnum(VoicePersonaProvider).optional(),
  llmModelCompatibilities: z.array(z.nativeEnum(LlmModelCompatibility)).optional(),
});
export type FindAllOptions = z.infer<typeof FindAllOptionsSchema>;
